import Vue from 'vue'

//Функция должна быть всеядной. В нее может передаваться просто строка,
//аякс-ответ, объект
Vue.prototype.$showError = function (error) {
  console.error('vue:error', error)
}
